// FocusZoneContext — mode "focus" pour cacher sidebar en lecture email/note.
// Source : PRD 10 §6 UX focus mode.
//
// Utilisation : un composant feature (EmailPreview, NoteEditor) set focusMode=true
// au mount → DashboardLayout réagit en cachant la sidebar. Reset au unmount.
import { createContext, useCallback, useContext, useMemo, useState } from "react";

export interface FocusZoneContextValue {
  focusMode: boolean;
  setFocusMode: (value: boolean) => void;
  toggleFocusMode: () => void;
}

const FocusZoneContext = createContext<FocusZoneContextValue | undefined>(undefined);

export function FocusZoneProvider({ children }: { children: React.ReactNode }) {
  const [focusMode, setFocusMode] = useState(false);

  const toggleFocusMode = useCallback(() => {
    setFocusMode((v) => !v);
  }, []);

  const value = useMemo<FocusZoneContextValue>(
    () => ({ focusMode, setFocusMode, toggleFocusMode }),
    [focusMode, toggleFocusMode],
  );

  return <FocusZoneContext.Provider value={value}>{children}</FocusZoneContext.Provider>;
}

export function useFocusZone(): FocusZoneContextValue {
  const ctx = useContext(FocusZoneContext);
  if (!ctx) throw new Error("useFocusZone must be used within FocusZoneProvider");
  return ctx;
}
